import { render, staticRenderFns } from "./EditPatientFormSign.vue?vue&type=template&id=8d6e452e&scoped=true"
import script from "./EditPatientFormSign.vue?vue&type=script&lang=js"
export * from "./EditPatientFormSign.vue?vue&type=script&lang=js"
import style0 from "./EditPatientFormSign.vue?vue&type=style&index=0&id=8d6e452e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6e452e",
  null
  
)

export default component.exports